{
  "version": 1,
  "asset_id": "1f5dbf28-4bb2-45d5-ab89-54b57c07d80a",
  "project_id": "1d7b8e6b-eeef-4a52-9dda-b5fbba0dd955",
  "url": "/__l5e/assets-v1/1f5dbf28-4bb2-45d5-ab89-54b57c07d80a/screen-enclosure-pool.jpg",
  "r2_key": "a/v1/1d7b8e6b-eeef-4a52-9dda-b5fbba0dd955/1f5dbf28-4bb2-45d5-ab89-54b57c07d80a/screen-enclosure-pool.jpg",
  "original_filename": "screen-enclosure-pool.jpg",
  "size": 295086,
  "content_type": "image/jpeg",
  "created_at": "2026-09-09T15:27:53Z"
}
